(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope = document) {
    const items = scope.querySelectorAll('[data-mlt-reveal]:not([data-mlt-bound])');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.mltBound = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

    items.forEach((item) => {
      item.dataset.mltBound = 'true';
      observer.observe(item);
    });
  }

  function initMomentCards(scope = document) {
    if (reduceMotion) return;
    scope.querySelectorAll('.mlt-moment-card:not([data-mlt-pointer])').forEach((card) => {
      card.dataset.mltPointer = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        card.style.setProperty('--my', `${event.clientY - rect.top}px`);
      });
    });
  }

  function initProofFilters(scope = document) {
    scope.querySelectorAll('[data-mlt-proof]:not([data-mlt-filter-bound])').forEach((section) => {
      section.dataset.mltFilterBound = 'true';
      const buttons = [...section.querySelectorAll('[data-mlt-filter]')];
      const cards = [...section.querySelectorAll('[data-mlt-proof-card]')];

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const wasActive = button.classList.contains('is-active');
          const filter = button.dataset.mltFilter;
          buttons.forEach((item) => item.classList.remove('is-active'));
          if (!wasActive) button.classList.add('is-active');
          cards.forEach((card) => {
            card.hidden = !wasActive && card.dataset.mltCategory !== filter;
          });
        });
      });
    });
  }

  function init(scope = document) {
    root.classList.add('mlt-motion-ready');
    initReveal(scope);
    initMomentCards(scope);
    initProofFilters(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
